import React from "react";
import "../../assets/css/NumericKeypad.css"

const keys = ["1","2","3","4","5","6","7","8","9","0"];

const NumericKeypad = ({ onPress, onDelete, onClear }) => {
  return (
    <div className="keypad">
      {keys.map((k) => (
        <button
          key={k}
          className="keypad-key"
          onClick={() => onPress(k)}
        >
          {k}
        </button>
      ))}

      <button className="keypad-key action" onClick={onDelete}>
        ⌫
      </button>

      <button className="keypad-key action clear" onClick={onClear}>
        C
      </button>
    </div>
  );
};

export default NumericKeypad;
